export default __webpack_public_path__ + "static/media/apple_app_store.db051042.png";